import React, {  } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from "@material-ui/core/Grid/Grid";


import Typography from "@material-ui/core/Typography";
import OperadorKpis from "./OperadorKpis";




const useStyles = makeStyles(theme => ({

    mainGrid: {
      margin: 0,
      display: 'flex',
     // height: '150mm',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      border: 1,
   //   borderStyle: 'solid',
      borderColor: '#378362',
      borderRadius: '5px',
      flexGrow: 1
    },
    gridTitulo: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',


        border: 1,
        borderStyle: 'solid',
   //     borderColor: 'black',
        borderRadius: '5px'
    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: "center",
        alignContent: 'center',
        border: 1,
    //    borderStyle: 'solid',
        borderColor: 'black',
        borderRadius: '5px',
        flexGrow: 0
    },


}));


export default function Operadores(props) {
  const { raspaReportData} = props;

  const classes = useStyles();


    return (
    <Grid container xs={12} className={classes.mainGrid}>
        <Grid container item id={'titulo'} className={classes.gridTitulo} sm={12} md={12}>
            <Typography>OPERADORES</Typography>
        </Grid>
        <Grid container item id={'gridCorrecaoAjuste'} className={classes.gridItem}  sm={12} md={12} >
            {
                raspaReportData.periodo.estatisticasPorOperador.map( (dataOper,ix) => {
                    return (<OperadorKpis key={`operdata-${ix}`} dataOper={dataOper}/>)
                })
            }


        </Grid>
    </Grid>
  )
}
;
